import { useFeatureValue } from '@growthbook/growthbook-react';
import React from 'react';
import { useLocale } from './contexts/LocaleContext';
import { typedWindow } from './lib/Window';

export function ChatEmbed() {
  const { country, language } = useLocale();
  const decagonChatEnabled = useFeatureValue('decagon-chat-widget', false);

  // If experiment is enabled for session, use Decagon chat, otherwise use Ada chat
  if (decagonChatEnabled) {
    if (document.getElementById('chat-loader')) return <></>;
    /**
     * Decagon pins a full-viewport fixed iframe that only draws the chat bubble
     * in its corner. iOS Safari routes pan gestures to cross-origin iframes
     * without honoring pointer-events, so the invisible overlay swallows
     * horizontal swipes page-wide. Shrink it to the bubble's corner on touch
     * devices only: the inline pointer-events toggles on mouse hover, not on
     * open/close, so on desktop the rule would clip the open panel as soon as
     * the cursor leaves it.
     */
    const panFix = document.createElement('style');
    panFix.id = 'decagon-pan-fix';
    panFix.textContent = [
      '@media (hover: none) {',
      '  iframe[src*="decagon.ai"][style*="pointer-events: none"] {',
      '    width: 120px !important;',
      '    height: 120px !important;',
      '  }',
      '}',
    ].join('\n');
    document.head.appendChild(panFix);
    const chatWidgetScript = document.createElement('script');
    chatWidgetScript.id = 'chat-loader';
    chatWidgetScript.src = 'https://decagon.ai/loaders/fi.js';
    chatWidgetScript.onload = () => {
      // Add user metadata containing the user's region for Decagon chat
      if (country && typedWindow.duet) {
        typedWindow.duet.setMetadata({
          userRegion: country,
          locale: language,
        });
      }
    };
    document.body.appendChild(chatWidgetScript);
  } else {
    if (document.getElementById('__ada')) return <></>;
    const adaScript = document.createElement('script');
    adaScript.src = 'https://static.ada.support/embed2.js';
    adaScript.dataset.handle = 'fi';
    adaScript.id = '__ada';
    document.body.appendChild(adaScript);
  }

  return <></>;
}
